<template>
    <div class="avance">
        <div class="container pb-5">
            <div v-if="learnings !== null && learnings.data && learnings.data.length" class="row">
                <div v-for="learning in learnings.data" class="col-12 col-md-4 col-md-6 col-lg-4">
                    <div :class="learning.users.length === 0 ? 'blue' : learning.users[0].pivot.status === 'pending' ? 'orange' : 'green'" class="d-flex cards-white mx-0 my-2 my-md-3 pe-0">
                        <div v-if="learning.users.length === 0" class="estado">Sin iniciar</div>
                        <div v-else-if=" learning.users[0].pivot.status === 'pending'" class="estado">Incompleto</div>
                        <div v-else-if=" learning.users[0].pivot.status === 'completed'" class="estado">Completado</div>
                        <div class="col-8 pe-3 text">
                            <p><strong>{{ learning.title }}</strong></p>
                            <p>
                                <strong class="d-block"></strong>
                                {{ learning.short_description }}
                            </p>
                            <a :href="`/learning/${learning.id}`" class="button-underline">
                                COMENZAR
                            </a>
                        </div>
                        <div class="col-4 d-flex align-items-center">
                            <div class="img-full">
                                <img v-if="learning.image" :src="url_storage+'storage/'+JSON.parse(learning.image)[0]" :alt="learning.title" class="fluid">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center" v-if="learnings.last_page > 1">
                    <div class="col-md-6 d-flex justify-content-center">
                        <ul class="pagination my-2">
                            <li class="page-item" :class="learnings.prev_page_url === null ? 'disable' : ''">
                                <a v-if="learnings.current_page-1 > 1" class="page-link cursor-pointer" @click="getLearnings(learnings.current_page - 1)">Anterior</a>
                                <span v-else class="cursor-block"></span>
                            </li>
                            <li class="page-item">
                                <a v-if="learnings.current_page-2 > 1" @click="getLearnings(1)" class="p-2 page-link cursor-pointer">{{ 1 }}</a>
                            </li>
                            <li v-if="learnings.current_page-2 >= 1" class="page-item">
                                <span class="page-link">...</span>
                            </li>
                            <li v-if="learnings.current_page > 1" class="page-item">
                                <a @click="getLearnings(learnings.current_page - 1)" class="p-2 page-link cursor-pointer">{{ learnings.current_page - 1 }}</a>
                            </li>
                            <li class="page-item active">
                                <a class="p-2 page-link cursor-default">{{ learnings.current_page }}</a>
                            </li>
                            <li v-if="learnings.current_page < learnings.last_page" class="page-item">
                                <a @click="getLearnings(learnings.current_page + 1)" class="p-2 page-link cursor-pointer">{{ learnings.current_page + 1 }}</a>
                            </li>
                            <li v-if="learnings.current_page+2 <= learnings.last_page" class="page-item">
                                <a class="p-2 page-link">...</a>
                            </li>
                            <li v-if="learnings.current_page+2 < learnings.last_page" class="page-item">
                                <a @click="getLearnings(learnings.last_page)" class="p-2 page-link cursor-pointer">{{ learnings.last_page }}</a>
                            </li>
                            <li class="page-item" :class="learnings.current_page >= learnings.last_page ? 'disable' : ''">
                                <span v-if="learnings.current_page !== learnings.last_page" @click="getLearnings(learnings.current_page + 1)" class="cursor-pointer">></span>
                                <span v-else class="cursor-block">></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div v-else-if="learnings === null && loading">
                <initial-loading></initial-loading>
            </div>
            <div v-else class="text-center py-10">
                <h5>Actualmente no hay contenido disponibles</h5>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        url_storage: {
            default: null,
        },
    },
    data() {
        return {
            loading: 0,
            learnings: null,
        }
    },
    mounted () {
        this.getLearnings(1)
    },
    methods: {
        getLearnings(page){
            this.loading++
            axios.get(`/get-learnings?page=${page}`)
                 .then(({data}) => {
                     this.learnings = data.learnings
                     this.loading--;
                 })
        },
    },
}

</script>
